import { Fragment, useEffect, useState } from 'react'
import { Button, FormFeedback } from 'reactstrap'
import { trans } from '@utils'

import { UncontrolledInputGroupBuilder } from '../input-group-builder'

const SlimModalPopupForm = (props) => {
  const {data, prefix, onSubmit, onClose} = props
  const [_value, _setValue] = useState({})
  const [error, setError] = useState('')
  const _onSubmit = (data) => {
    setError('')
    if (
      _.isEmpty(data) || 
      _.isEmpty(data.value) || 
      (_.isArray(data.value) && _.find(data.value, v => _.isEmpty(v)) === '')
    ) {
      setError(trans('gen.validations.required'))
      return
    }
    onSubmit(data)
  }
  useEffect(() => {
    if (data.value && _.size(data.value) > 0) {
      _setValue(data.value)
    }
  }, [])
  return (
    <Fragment>
      <div className={'mb-50 h4'}>
        {prefix && <span className='mr-50'>{prefix}:</span>}
        <span>{data.option.label}</span>
      </div>
      <div className={'p-50 border-radius-5 d-flex'} style={{ backgroundColor: '#FFF9E7' }}>
        {_.includes(['text', 'textarea', 'email', 'phone'], data.option.type) && 
          <UncontrolledInputGroupBuilder
            type={'text'}
            value={_.size(_value) > 0 ? [_value] : []}
            onChange={(data) => _setValue(data[0])}
            filterOperators={data.option.filterOperators ? (args) => data.option.filterOperators({ key: data.option.value, ...args }) : null}
            autoFocus={true}
          />
        }
        {_.includes(['number', 'integer', 'decimal'], data.option.type) && 
          <UncontrolledInputGroupBuilder
            type={'number'}
            value={_.size(_value) > 0 ? [_value] : []}
            onChange={(data) => _setValue(data[0])}
            filterOperators={data.option.filterOperators ? (args) => data.option.filterOperators({ key: data.option.value, ...args }) : null}
            autoFocus={true}
          />
        }
        {data.option.type === 'asyncSelect' && 
          <UncontrolledInputGroupBuilder
            type={'asyncSelect'}
            remoteUrl={_.get(data.option, 'remoteUrl', '')}
            isMulti={_.get(data.option, 'isMulti', false)}
            remoteUrlFormatter={_.get(data.option, 'remoteUrlFormatter', null)}
            optionFormatter={_.get(data.option, 'optionFormatter', null)}
            filterOperators={data.option.filterOperators ? (args) => data.option.filterOperators({ key: data.option.value, ...args }) : null}
            value={_.size(_value) > 0 ? [_value] : []}
            onChange={(data) => _setValue(data[0])}
            autoFocus={true}
          />
        }
      </div>
      {error && <FormFeedback className={'d-flex text-danger'}>{error}</FormFeedback>}
      <div className={'d-flex justify-content-end mt-50'}>
        <Button color="flat-secondary" onClick={onClose}>{trans('gen.actions.cancel')}</Button>
        <Button className={'ml-25'} color="primary" onClick={() => _onSubmit(_value)}>{trans('gen.actions.apply')}</Button>
      </div>
    </Fragment>
  )
}

export default SlimModalPopupForm